/**
 * 対応通貨一覧
 */
export const supportedCurrencies = [
  { code: 'JPY', symbol: '¥', label: 'Japanese Yen', icon: '/icon/currencies/JPY.svg' },
  { code: 'USD', symbol: '$', label: 'United States Dollar', icon: '/icon/currencies/USD.svg' },
  { code: 'AUD', symbol: 'A$', label: 'Australian Dollar', icon: '/icon/currencies/AUD.svg' },
  { code: 'EUR', symbol: '€', label: 'Euro', icon: '/icon/currencies/EUR.svg' },
  { code: 'GBP', symbol: '£', label: 'British Pound Sterling', icon: '/icon/currencies/GBP.svg' },
  { code: 'CAD', symbol: 'C$', label: 'Canadian Dollar', icon: '/icon/currencies/CAD.svg' },
  { code: 'CHF', symbol: 'CHF ', label: 'Swiss Franc', icon: '/icon/currencies/CHF.svg' },
  { code: 'MXN', symbol: 'Mex$', label: 'Mexican Peso', icon: '/icon/currencies/MXN.svg' },
] as const;

/**
 * 対応通貨の型定義
 */
export type Currency = (typeof supportedCurrencies)[number]['code'];

/**
 * 通貨コードに対応するシンボルのマップ
 */
export const CURRENCY_SYMBOLS: Record<string, string> = Object.fromEntries(supportedCurrencies.map((c) => [c.code, c.symbol]));

/**
 * 金額と通貨コードをフォーマットして文字列で返す
 * @param amount 金額（整数に四捨五入して表示する）
 * @param currency 通貨コード
 * @returns フォーマットされた価格文字列
 */
export const formatCurrency = (amount: number, currency: string): string => {
  const symbol = CURRENCY_SYMBOLS[currency] || '';
  return `${symbol}${Math.round(amount).toLocaleString()}`;
};
